// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"43daa8aa","286":"a49d69b9","887":"2053dcd3","916":"ef88f1c9","917":"d3d2cdb2"}[chunkId] + ".chunk.css";
};